import React from "react";
import App from "./../app.jsx";
import { Navigate, useLocation } from "react-router-dom";

import Dashboard from "./../pages/dashboard/dashboard.js";
import Analytics from "./../pages/analytics/analytics.js";
import EmailInbox from "./../pages/email/inbox.js";
import EmailCompose from "./../pages/email/compose.js";
import EmailDetail from "./../pages/email/detail.js";
import EmailAnalytics from "./../pages/email/analytics.js";
import EmailTools from "./../pages/email/tools.js";
import EmailContract from "./../pages/email/contract.js";
import CreateDetail from "./../pages/email/create.js";
import CreateRequest from "./../pages/email/request.js";
import CreateRequests from "./../pages/email/requests.js";
import CreateChart from "./../pages/email/charts.js";
import CreateRanking from "./../pages/email/ranking.js";
import CreateInvoiced from "./../pages/email/invoiced.js";
import UpdateDetail from "./../pages/email/update.js";
import VentasTotales from "./../pages/email/ventas.js";
import CreateVenta from "./../pages/email/crear_venta.js";
import Widgets from "./../pages/widgets/widgets.js";
import PosCustomerOrder from "./../pages/pos/customer-order.js";
import PosCustomerOrderV2 from "./../pages/pos/customer-order-v2.js";
import AddonsInventoryByFolio from "./../pages/pos/addons.js";
import PosKitchenOrder from "./../pages/pos/kitchen-order.js";
import PosCounterCheckout from "./../pages/pos/counter-checkout.js";
import PosTableBooking from "./../pages/pos/table-booking.js";
import PosMenuStock from "./../pages/pos/menu-stock.js";
import UiBootstrap from "./../pages/ui/bootstrap.js";
import UiButtons from "./../pages/ui/buttons.js";
import UiCard from "./../pages/ui/card.js";
import UiIcons from "./../pages/ui/icons.js";
import UiModalNotifications from "./../pages/ui/modal-notifications.js";
import UiTypography from "./../pages/ui/typography.js";
import UiTabsAccordions from "./../pages/ui/tabs-accordions.js";
import FormElements from "./../pages/form/elements.js";
import FormPlugins from "./../pages/form/plugins.js";
import FormWizards from "./../pages/form/wizards.js";
import TableElements from "./../pages/table/elements.js";
import TablePlugins from "./../pages/table/plugins.js";
import ChartJs from "./../pages/charts/js.js";
import ChartApex from "./../pages/charts/apex.js";
import Map from "./../pages/map/map.js";
import LayoutStarter from "./../pages/layout/starter.js";
import LayoutFixedFooter from "./../pages/layout/fixed-footer.js";
import LayoutFullHeight from "./../pages/layout/full-height.js";
import LayoutFullWidth from "./../pages/layout/full-width.js";
import LayoutBoxedLayout from "./../pages/layout/boxed-layout.js";
import LayoutCollapsedSidebar from "./../pages/layout/collapsed-sidebar.js";
import LayoutTopNav from "./../pages/layout/top-nav.js";
import LayoutMixedNav from "./../pages/layout/mixed-nav.js";
import LayoutMixedNavBoxedLayout from "./../pages/layout/mixed-nav-boxed-layout.js";
import PagesScrumBoard from "./../pages/pages/scrum-board.js";
import PagesProducts from "./../pages/pages/products.js";
import PagesProductDetails from "./../pages/pages/product-details.js";
import PagesOrders from "./../pages/pages/orders.js";
import PagesOrderDetails from "./../pages/pages/order-details.js";
import PagesGallery from "./../pages/pages/gallery.js";
import PagesSearchResults from "./../pages/pages/search-results.js";
import PagesComingSoon from "./../pages/pages/coming-soon.js";
import PagesError from "./../pages/pages/error.js";
import PagesLogin from "./../pages/pages/login.js";
import PagesRegister from "./../pages/pages/register.js";
import PagesDataManagement from "./../pages/pages/data-management.js";
import PagesPricing from "./../pages/pages/pricing.js";
import Messenger from "./../pages/messenger/messenger.js";
import FileManager from "./../pages/file-manager/file-manager.js";
import Profile from "./../pages/profile/profile.js";
import Calendar from "./../pages/calendar/calendar.js";
import Settings from "./../pages/settings/settings.js";
import Helper from "./../pages/helper/helper.js";
import { isAuthenticated } from "./../pages/pages/auth";
import DashboardRendimiento from "../pages/rendimiento/dashboard-rendimiento.js";

// Facturación
import FacturacionComparativo from "../pages/facturacion/comparativo.js";
import FacturacionFacturas from "../pages/facturacion/facturas.js";
import FacturacionGraficas from "../pages/facturacion/graficas.js";

// Admin
import BabiloniaCatalogAdmin from "../pages/babilonia/catalogo-admin.js";
import BabiloniaUsersAdmin from "../pages/babilonia/usuarios-admin.js";
import BabiloniaAgenciasCotizadorAdmin from "../pages/babilonia/agencias-cotizador-admin.js";

import Rendimiento from "../pages/email/rendimiento.js";

//NR
import CreateVentaNRUnified  from "./../pages/email/crearventa.js";

const CATALOG_ADMIN_ALLOWED_EMAILS = [
  "jaime.reyesr22@gmail.com",
  // "alombera@gocar.auto",
  // "roberto.martinez@gocar.auto",
  // "wtorres@gocar.auto",
  // "rmaldonado@gocar.auto",
];

const normalizeEmail = (email = "") =>
  String(email || "")
    .trim()
    .toLowerCase();

const getLoggedUserEmail = () =>
  normalizeEmail(localStorage.getItem("userEmail") ?? "");

const getUserModules = () => {
  try {
    const rawModules = localStorage.getItem("modulos");

    if (!rawModules) return [];

    const parsedModules = JSON.parse(rawModules);

    if (Array.isArray(parsedModules)) {
      return parsedModules.map((module) => String(module).trim());
    }

    if (typeof parsedModules === "string") {
      try {
        const parsedAgain = JSON.parse(parsedModules);

        if (Array.isArray(parsedAgain)) {
          return parsedAgain.map((module) => String(module).trim());
        }
      } catch (error) {
        return parsedModules
          .split(",")
          .map((module) => module.trim())
          .filter(Boolean);
      }
    }

    return [];
  } catch (error) {
    return [];
  }
};

export const PrivateRoute = ({ children, requiredModule, allowedEmails }) => {
  const location = useLocation();
  const userModules = getUserModules();
  const token = localStorage.getItem("accessToken");

  if (!token) {
    return <Navigate to="/pages/login" state={{ from: location }} replace />;
  }

  const hasRequiredModule =
    !requiredModule ||
    (Array.isArray(userModules) &&
      userModules.some((module) => module === requiredModule));

  if (!hasRequiredModule) {
    return <Navigate to="/pages/error" />;
  }

  if (allowedEmails && allowedEmails.length > 0) {
    const userEmail = getLoggedUserEmail();

    const allowed = allowedEmails
      .map((email) => normalizeEmail(email))
      .includes(userEmail);

    if (!allowed) {
      return <Navigate to="/pages/error" />;
    }
  }

  return children;
};

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "",
        element: isAuthenticated() ? (
          <Navigate to="/analytics" />
        ) : (
          <Navigate to="/pages/login" />
        ),
      },
      {
        path: "dashboard",
        element: (
          <PrivateRoute requiredModule="dashboard">
            <Dashboard />
          </PrivateRoute>
        ),
      },
      {
        path: "analytics",
        element: (
          <PrivateRoute requiredModule="analytics">
            <DashboardRendimiento />
          </PrivateRoute>
        ),
      },
      {
        path: "deals/*",
        children: [
          {
            path: "inbox",
            element: (
              <PrivateRoute requiredModule="deals-inbox">
                <EmailInbox />
              </PrivateRoute>
            ),
          },
          {
            path: "compose",
            element: (
              <PrivateRoute requiredModule="deals-compose">
                <EmailCompose />
              </PrivateRoute>
            ),
          },
          {
            path: "detail",
            element: (
              <PrivateRoute requiredModule="deals-detail">
                <EmailDetail />
              </PrivateRoute>
            ),
          },
          {
            path: "create",
            element: (
              <PrivateRoute requiredModule="deals-create">
                <CreateDetail />
              </PrivateRoute>
            ),
          },
          {
            path: "request",
            element: (
              <PrivateRoute requiredModule="deals-request">
                <CreateRequest />
              </PrivateRoute>
            ),
          },
          {
            path: "requests",
            element: (
              <PrivateRoute requiredModule="deals-requests">
                <CreateRequests />
              </PrivateRoute>
            ),
          },
          {
            path: "charts",
            element: (
              <PrivateRoute requiredModule="deals-charts">
                <CreateChart />
              </PrivateRoute>
            ),
          },
          {
            path: "ranking",
            element: (
              <PrivateRoute requiredModule="deals-ranking">
                <CreateRanking />
              </PrivateRoute>
            ),
          },
          {
            path: "invoiced",
            element: (
              <PrivateRoute requiredModule="deals-invoiced">
                <CreateInvoiced />
              </PrivateRoute>
            ),
          },
          {
            path: "update",
            element: (
              <PrivateRoute requiredModule="deals-update">
                <UpdateDetail />
              </PrivateRoute>
            ),
          },
          {
            path: "analytics",
            element: (
              <PrivateRoute requiredModule="deals-analytics">
                <EmailAnalytics />
              </PrivateRoute>
            ),
          },
          {
            path: "tools",
            element: (
              <PrivateRoute requiredModule="deals-tools">
                <EmailTools />
              </PrivateRoute>
            ),
          },
          {
            path: "contract",
            element: (
              <PrivateRoute requiredModule="deals-contract">
                <EmailContract />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "pos/*",
        children: [
          {
            path: "customer-order",
            element: <PosCustomerOrder />,
          },
          {
            path: "customer-order-v2",
            element: (
              <PrivateRoute requiredModule="form-wizards">
                <PosCustomerOrderV2 />
              </PrivateRoute>
            ),
          },
          {
            path: "addons",
            element: <AddonsInventoryByFolio />,
          },
          {
            path: "kitchen-order",
            element: (
              <PrivateRoute requiredModule="pos">
                <PosKitchenOrder />
              </PrivateRoute>
            ),
          },
          {
            path: "counter-checkout",
            element: (
              <PrivateRoute requiredModule="pos">
                <PosCounterCheckout />
              </PrivateRoute>
            ),
          },
          {
            path: "table-booking",
            element: (
              <PrivateRoute requiredModule="pos">
                <PosTableBooking />
              </PrivateRoute>
            ),
          },
          {
            path: "menu-stock",
            element: (
              <PrivateRoute requiredModule="pos">
                <PosMenuStock />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "form/*",
        children: [
          {
            path: "wizards",
            element: (
              <PrivateRoute requiredModule="form-wizards">
                <FormWizards />
              </PrivateRoute>
            ),
          },
          {
            path: "ventas",
            element: (
              <PrivateRoute requiredModule="form-wizards">
                <VentasTotales />
              </PrivateRoute>
            ),
          },
          {
            path: "crear-venta-nr",
            element: (
              <PrivateRoute requiredModule="form-wizards">
                <CreateVentaNRUnified />
              </PrivateRoute>
            ),
          },
            {
            path: "crear-venta",
            element: (
              <PrivateRoute requiredModule="form-wizards">
                <CreateVenta />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "pages/*",
        children: [
          {
            path: "error",
            element: <PagesError />,
          },
          {
            path: "login",
            element: <PagesLogin />,
          },
          {
            path: "register",
            element: (
              <PrivateRoute requiredModule="admin">
                <PagesRegister />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "rendimiento",
        element: (
          <PrivateRoute requiredModule="rendimiento">
            <Rendimiento />
          </PrivateRoute>
        ),
      },
      {
        path: "dashboard-rendimiento",
        element: (
          <PrivateRoute>
            <DashboardRendimiento />
          </PrivateRoute>
        ),
      },
      {
        path: "babilonia/catalogo-admin",
        element: (
          <PrivateRoute allowedEmails={CATALOG_ADMIN_ALLOWED_EMAILS}>
            <BabiloniaCatalogAdmin />
          </PrivateRoute>
        ),
      },
      {
        path: "babilonia/usuarios-admin",
        element: (
          <PrivateRoute allowedEmails={CATALOG_ADMIN_ALLOWED_EMAILS}>
            <BabiloniaUsersAdmin />
          </PrivateRoute>
        ),
      },
      {
        path: "babilonia/agencias-cotizador-admin",
        element: (
          <PrivateRoute allowedEmails={CATALOG_ADMIN_ALLOWED_EMAILS}>
            <BabiloniaAgenciasCotizadorAdmin />
          </PrivateRoute>
        ),
      },
      {
        path: "facturacion/*",
        children: [
          {
            path: "",
            element: <Navigate to="/facturacion/comparativo" />,
          },
          {
            path: "comparativo",
            element: (
              <PrivateRoute>
                <FacturacionComparativo />
              </PrivateRoute>
            ),
          },
          {
            path: "facturas",
            element: (
              <PrivateRoute>
                <FacturacionFacturas />
              </PrivateRoute>
            ),
          },
          {
            path: "graficas",
            element: (
              <PrivateRoute>
                <FacturacionGraficas />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "*",
        element: <PagesError />,
      },
    ],
  },
];

export default AppRoute;
